import React from "react";
import * as S from "./FilterBarStyles";

const FilterBar = ({ filters, onFilterSelect,selectedFilters }) => {
  return (
    <S.FilterBar>
      {filters.map((filter, index) => (
        <S.FilterItem key={index} onClick={() => onFilterSelect(filter)} selected={selectedFilters?.includes(filter)}>
          <S.FilterText>{filter}</S.FilterText>
        </S.FilterItem>
      ))}
    </S.FilterBar>
  );
};

export default FilterBar;
